<vs-card class="my-4">
  <vs-card-header
    [config]="{
      title: 'Account Information',
      subtitle: 'View the account information of this distributor.'
    }"
  ></vs-card-header>

  <vs-card-content class="grid gap-4 text-sm" style="grid-template-columns: auto 1fr">
    <div class="font-medium">Agent/Referral Source</div>
    <div class="truncate">{{ distributor?.referralSource ?? '' }}</div>

    <vs-divider class="col-span-2"></vs-divider>

    <div class="font-medium">ACH name on account</div>
    <div class="truncate">{{ distributor?.achName ?? '' }}</div>

    <vs-divider class="col-span-2"></vs-divider>

    <div class="font-medium">Bank Name</div>
    <div class="truncate">{{ distributor?.bankName ?? '' }}</div>

    <vs-divider class="col-span-2"></vs-divider>

    <div class="font-medium">Type</div>
    <div class="truncate">{{ distributor?.accountType ?? '' }}</div>

    <vs-divider class="col-span-2"></vs-divider>

    <div class="font-medium">Account</div>
    <div class="truncate">{{ maskSensitiveValue(distributor?.accountNumber) }}</div>

    <vs-divider class="col-span-2"></vs-divider>

    <div class="font-medium">Routing</div>
    <div class="truncate">{{ maskSensitiveValue(distributor?.routingNumber) }}</div>

    <vs-divider class="col-span-2"></vs-divider>

    <div class="font-medium">W9 Link</div>
    <div class="truncate">{{ distributor?.w9Link ?? '' }}</div>
  </vs-card-content>
</vs-card>
